var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:""},[_c('v-main',[_c('div',{staticClass:"head px-4"},[_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("sdsd")]),_vm._v(" "),_c('div',{staticClass:"hero"},[_c('h1',[_vm._v("sada")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f703b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Master/Blog.vue
// module id = null
// module chunks = 